import { render, staticRenderFns } from "./MeusCadernosPerfil.vue?vue&type=template&id=15368331&scoped=true&"
import script from "./MeusCadernosPerfil.vue?vue&type=script&lang=js&"
export * from "./MeusCadernosPerfil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15368331",
  null
  
)

export default component.exports